import { render } from "./OrderNotes.vue?vue&type=template&id=0f6096e4&scoped=true"
import script from "./OrderNotes.vue?vue&type=script&lang=js"
export * from "./OrderNotes.vue?vue&type=script&lang=js"

import "./OrderNotes.vue?vue&type=style&index=0&id=0f6096e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6096e4"]])

export default __exports__